import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import {
  ILineWatchdogSetting,
  ILineWatchdogSettingRow,
} from '../../../../view/settings/api-automation-settings/line-watchdog-settings/line-watchdog-settings.model';
import {
  ActivityCRUDInterface,
  LineCRUDInterface,
  SiteCRUDInterface,
} from '../../../../shared/component/filter/filter.class';
import { SimplifiedDataInterface } from '../../tasks/tasks.model';

export enum ActionTypes {
  LINE_WATCHDOG_SETTINGS_DATA_LOADING = '[LINE_WATCHDOG_SETTINGS] LINE_WATCHDOG_SETTINGS DATA LOADING',
  LINE_WATCHDOG_SETTINGS_DATA_LOADED = '[LINE_WATCHDOG_SETTINGS] LINE_WATCHDOG_SETTINGS DATA LOADED',
  GET_LINE_WATCHDOG_SETTING = '[LINE_WATCHDOG_SETTINGS] GET_LINE_WATCHDOG_SETTING LOADING',
  GET_LINE_WATCHDOG_SETTING_COMPLETED = '[LINE_WATCHDOG_SETTINGS] GET_LINE_WATCHDOG_SETTING COMPLETED',
  ADD_LINE_WATCHDOG_SETTING = '[LINE_WATCHDOG_SETTINGS] ADD_LINE_WATCHDOG_SETTING',
  ADD_LINE_WATCHDOG_SETTING_COMPLETED = '[LINE_WATCHDOG_SETTINGS] ADD_LINE_WATCHDOG_SETTING COMPLETED',
  EDIT_LINE_WATCHDOG_SETTING = '[LINE_WATCHDOG_SETTINGS] EDIT_LINE_WATCHDOG_SETTING',
  EDIT_LINE_WATCHDOG_SETTING_COMPLETED = '[LINE_WATCHDOG_SETTINGS] EDIT_LINE_WATCHDOG_SETTING COMPLETED',
  DELETE_LINE_WATCHDOG_SETTINGS = '[LINE_WATCHDOG_SETTINGS] DELETE_LINE_WATCHDOG_SETTINGS',
  DELETE_LINE_WATCHDOG_SETTINGS_COMPLETED = '[LINE_WATCHDOG_SETTINGS] DELETE_LINE_WATCHDOG_SETTINGS COMPLETED',
  SITES_DATA_LOADING = '[LINE_WATCHDOG_SETTINGS] SITES DATA LOADING',
  SITES_DATA_COMPLETED = '[LINE_WATCHDOG_SETTINGS] SITES DATA COMPLETED',
  LINES_DATA_LOADING = '[LINE_WATCHDOG_SETTINGS] LINES DATA LOADING',
  LINES_DATA_COMPLETED = '[LINE_WATCHDOG_SETTINGS] LINES DATA COMPLETED',
  ACTIVITIES_DATA_LOADING = '[LINE_WATCHDOG_SETTINGS] ACTIVITIES DATA LOADING',
  ACTIVITIES_DATA_COMPLETED = '[LINE_WATCHDOG_SETTINGS] ACTIVITIES DATA COMPLETED',
  FETCH_ERROR = '[LINE_WATCHDOG_SETTINGS] FETCH ERROR',
}

export class LineWatchdogSettingsLoading implements Action {
  readonly type = ActionTypes.LINE_WATCHDOG_SETTINGS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class LineWatchdogSettingsLoaded implements Action {
  readonly type = ActionTypes.LINE_WATCHDOG_SETTINGS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<ILineWatchdogSetting>) {}
}

export class GetLineWatchdogSetting implements Action {
  readonly type = ActionTypes.GET_LINE_WATCHDOG_SETTING;

  constructor(public recordId: number) {}
}

export class GetLineWatchdogSettingCompleted implements Action {
  readonly type = ActionTypes.GET_LINE_WATCHDOG_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILineWatchdogSetting>) {}
}
export class AddLineWatchdogSetting implements Action {
  readonly type = ActionTypes.ADD_LINE_WATCHDOG_SETTING;

  constructor(
    public record: ILineWatchdogSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddLineWatchdogSettingCompleted implements Action {
  readonly type = ActionTypes.ADD_LINE_WATCHDOG_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILineWatchdogSetting>) {}
}
export class EditLineWatchdogSetting implements Action {
  readonly type = ActionTypes.EDIT_LINE_WATCHDOG_SETTING;

  constructor(
    public recordId: number,
    public record: ILineWatchdogSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditLineWatchdogSettingCompleted implements Action {
  readonly type = ActionTypes.EDIT_LINE_WATCHDOG_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILineWatchdogSetting>) {}
}
export class DeleteLineWatchdogSettings implements Action {
  readonly type = ActionTypes.DELETE_LINE_WATCHDOG_SETTINGS;

  constructor(public payload: number[]) {}
}

export class DeleteLineWatchdogSettingsCompleted implements Action {
  readonly type = ActionTypes.DELETE_LINE_WATCHDOG_SETTINGS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class SiteDataLoading implements Action {
  readonly type = ActionTypes.SITES_DATA_LOADING;

  constructor() {}
}

export class SiteDataCompleted implements Action {
  readonly type = ActionTypes.SITES_DATA_COMPLETED;

  constructor(public payload: (SimplifiedDataInterface & Partial<SiteCRUDInterface>)[]) {}
}
export class LineDataLoading implements Action {
  readonly type = ActionTypes.LINES_DATA_LOADING;

  constructor(public siteId: number) {}
}

export class LineDataCompleted implements Action {
  readonly type = ActionTypes.LINES_DATA_COMPLETED;

  constructor(public payload: GetManyResponseInterface<Partial<LineCRUDInterface>>) {}
}
export class ActivitiesDataLoading implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_LOADING;

  constructor() {}
}

export class ActivitiesDataCompleted implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_COMPLETED;

  constructor(public payload: ActivityCRUDInterface[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type LineWatchdogSettingActions =
  | LineWatchdogSettingsLoading
  | LineWatchdogSettingsLoaded
  | GetLineWatchdogSetting
  | GetLineWatchdogSettingCompleted
  | AddLineWatchdogSetting
  | AddLineWatchdogSettingCompleted
  | EditLineWatchdogSetting
  | EditLineWatchdogSettingCompleted
  | DeleteLineWatchdogSettings
  | DeleteLineWatchdogSettingsCompleted
  | SiteDataLoading
  | SiteDataCompleted
  | LineDataLoading
  | LineDataCompleted
  | ActivitiesDataLoading
  | ActivitiesDataCompleted
  | FetchError;
